import { PureComponent } from 'preact-compat'
import { render } from 'preact-render-to-string'

import { ContentType } from '@insided/shared/utils/contentType'

import { assignIdeaStatus, replyToTopic } from '../services/topicService'
import { IdeaStatus } from '../interfaces'

/* eslint-disable import/no-internal-modules */
import tracker from '../../../../../components/tracker/publish'
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import IdeationStatusUpdated from '@insided/deprecated-control/ideas/auto-replies/IdeationStatusUpdated'
import ButtonControl from '@insided/deprecated-preact-components/button-control'

interface Props {
  topicId: number
  contentType: ContentType
  ideationStatus: IdeaStatus
  ideationStatuses: IdeaStatus[]
  onIdeationStatusChanged: (ideationStatus: IdeaStatus) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  getReplies: () => void
}

class ChangeIdeationStatus extends PureComponent<Props> {
  constructor() {
    super()
    this.onIdeationStatusChanged = this.onIdeationStatusChanged.bind(this)
  }

  async onIdeationStatusChanged(newIdeationStatus: IdeaStatus) {
    const {
      ideationStatus,
      contentType,
      topicId,
      onShowAlert,
      onIdeationStatusChanged,
      getReplies
    } = this.props
    const oldIdeationStatus = { ...ideationStatus }
    try {
      await assignIdeaStatus(contentType, topicId, newIdeationStatus.id)

      onIdeationStatusChanged(newIdeationStatus)
      onShowAlert('success', 'Ideation status has been updated!')

      tracker.trackEvent('userevent', {
        type: 'Idea status assigned',
        ideaId: topicId,
        ideaStatusId: newIdeationStatus.id
      })

      const autoReply = render(
        <IdeationStatusUpdated
          oldIdeationStatus={oldIdeationStatus}
          newIdeationStatus={newIdeationStatus}
        />
      )

      await replyToTopic(contentType, topicId, autoReply)
      await getReplies()
    } catch {
      onShowAlert('error')
    }
  }

  render() {
    const { ideationStatus, ideationStatuses } = this.props
    const dropdownItems = ideationStatuses
      .filter(
        (anyIdeationStatus) => ideationStatus.visible && anyIdeationStatus.id !== ideationStatus.id
      )
      .map((ideationStatus) => ({
        title: ideationStatus.name,
        value: ideationStatus.id,
        onClick: async () => await this.onIdeationStatusChanged(ideationStatus)
      }))

    return (
      <DropdownControl
        align='adjust'
        triggerClass='dropdown-wrapper'
        trigger={
          <ButtonControl
            icon='arrowDropdown'
            title={ideationStatus ? ideationStatus.name : 'Select an idea status'}
              // eslint-disable-next-line @gorazdo/preact/prefer-classname
            class='qa-topic-moderation-change-idea-status'
          />
        }
        items={dropdownItems}
      />
    )
  }
}

export default ChangeIdeationStatus
